import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Select, Button } from 'components'
import styles from './index.module.css'

const HomeDetailNone = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pt_0">
					<div className="flex-justify_end">
						<span className="link-top" style={{ color: "#999" }}>수정</span>
					</div>
					<div className={`${styles["home-address"]} pt_30`}>
						경기 성남시 분당구 판교역로 235<i className="icon icon_copy ml_5" />
					</div>
					<div className={`${styles["home-title"]} mt_5`}>에이치스퀘어 엔동</div>
					<div className={`${styles["tag-area"]} mt_10`}>
						<i className="tag tag-box tag-gray normal">아파트</i>
						<i className="tag tag-box tag-gray normal">월세</i>
					</div>
					<div className={`${styles["home-price"]} mt_20`}>7억 3,500만원</div>
					<hr className="my_40" />
					<div className={styles["list-item"]}>
						<div>
							<span>전용면적</span>
							<span>- ㎡</span>
						</div>
					</div>
				</div>
			</div>

			{/* 데이터 없을 때 */}
			<div className="center-cont py_50">
				<i className="icon icon_no_data" />
				<p className="mt_20">부동산 시세 정보가 없네요.<br />매일 업데이트 되고 있으니,<br />조금만 기다려주세요.</p>
			</div>
		</div>
	)
}

export default HomeDetailNone